<template>
  <div>
    <sc-text tag="h1" :field="title" />
    <sc-text tag="h2" :field="subTitle" />
    <sc-image :media="image" :editable="true" title="Page Featured Image" class="resource-img" />
  </div>
</template>

<script>
import { Text, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-ResourceHeading',
  props: {
    title: {
      type: Object
    },
    subTitle: {
      type: Object
    },
    image: {
      type: Object
    }
  },
  components: {
    ScText: Text,
    ScImage: Image
  }
};
</script>
<style lang="scss">
.resource-img {
  max-width: 70%;
  margin-bottom: 2rem;
}
</style>
